"use client";

import CTA from "@/components/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const laptopBogor: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-2">Jalan Pintas Cerdas: Sewa Laptop Bogor Tanpa Drama</h2>

    <h3 className="text-lg font-semibold mb-2">
      Sewa Laptop Bogor Cocok Buat Kamu yang Mau Hemat, Cepat, & Efisien
    </h3>

    <p className="mb-4">
      Kota Bogor bukan cuma dikenal karena hujan²nya, tapi juga karena padatnya aktivitas: seminar, pelatihan ASN, kerja proyek, digitalisasi sekolah, bahkan tender instansi pemerintah. Dalam kondisi seperti ini, <strong>sewa laptop Bogor</strong> bukan lagi sekadar solusi, tapi keharusan. Kamu hemat anggaran, waktu, dan tenaga.
    </p>

    <ul className="space-y-4 mb-6">
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Sewa Laptop Bogor Harga Fleksibel Sesuai Budget</h4>
        <p className="text-sm">
          Mulai dari harian sampai bulanan, kami siap sesuaikan dengan kebutuhan. Mau <strong>sewa laptop Bogor</strong> tipe standar sampai spek tinggi seperti Core i7, RAM 16GB, SSD 512GB? Semua ada. Brand ternama seperti Lenovo, ASUS, Dell, HP? Ready. Bahkan 1 unit atau 500 unit, semua bisa.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Jangkauan Luas: Dari Cibinong sampai Sentul</h4>
        <p className="text-sm">
          Mau antar ke Dramaga, Gunung Putri, Citeureup, Ciawi, Bojonggede, atau tengah kota Bogor? <strong>Sewa laptop Bogor</strong> siap antar jemput langsung ke lokasi kamu. Kami bergerak cepat, support aktif, dan logistik sudah terbiasa handle ribuan unit.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Laptop Siap Pakai, Tinggal Nyalakan</h4>
        <p className="text-sm">
          Semua <strong>laptop sewa Bogor</strong> sudah kami setting lengkap: Office, Zoom, browser, software training—siap kerja. Enggak perlu setting² ulang. Bahkan untuk pelatihan berskala besar, kami bantu pre-setup sesuai kebutuhan.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Teknisi & Support Cepat Tanggap</h4>
        <p className="text-sm">
          Kalau tiba² ada kendala teknis saat acara, langsung kami ganti unit. Kami paham: waktu kamu terlalu berharga buat nunggu. Maka <strong>sewa laptop di Bogor</strong> ini lengkap dengan SLA & garansi teknis onsite.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Harga Transparan, Tanpa Biaya Tersembunyi</h4>
        <p className="text-sm">
          Semua biaya dijelaskan di awal. <strong>Sewa laptop Bogor</strong> dijamin tanpa biaya siluman. Semakin lama durasi sewa, makin hemat. Mau kontrak jangka panjang? Bisa disesuaikan dengan termin pembayaran.
        </p>
      </li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Sewa Laptop Bogor untuk Semua Kebutuhan</h2>
    <p className="mb-4">
      Event di kampus IPB? Workshop daring? Kantor startup? Tender pemda? <strong>Sewa laptop Bogor</strong> sudah terbukti membantu berbagai sektor. Kualitas unit terjaga, delivery on-time, dan layanan profesional jadi standar harian kami.
    </p>

    <h2 className="text-xl font-bold mb-3">Durasi Fleksibel: Harian, Mingguan, Bulanan</h2>
    <p className="mb-4">
      Ada yang sewa buat satu hari acara, ada juga yang buat 3 bulan digitalisasi sekolah. <strong>Sewa laptop Bogor</strong> mendukung semua skema: mulai dari event singkat hingga proyek jangka panjang. Kami fleksibel, kamu tenang.
    </p>

    <h2 className="text-xl font-bold mb-3">Sewa Laptop Bogor dengan Maintenance Onsite</h2>
    <p className="mb-4">
      Selama masa sewa, kamu enggak jalan sendiri. Kami bantu maintenance, install ulang, hingga upgrade ringan. <strong>Sewa laptop Bogor</strong> bukan cuma antar unit, tapi juga full support dari awal sampai akhir.
    </p>

    <CTA
      title="Siap Kerja Editing & Olah Data Dimana² Bosku?"
      description="🚚 Butuh sewa laptop terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Laptop Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20laptop.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ category="Laptop" />
  </>
);

export default laptopBogor;